// extracted by mini-css-extract-plugin
module.exports = {"white100":"#fff","primary":"#400099","primaryD10":"#2b0066","List":"medkit__List__List","List__item":"medkit__List__List__item"};